import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import helpers from 'src/helpers';

function ProgressBar({
  currentValuePercentages,
  containerOptions = {},
  linearProgressOptions = {},
  colorPrimary = '#EEEEEE',
  colorBar = '#57B894',
}) {
  const linearProgressValue = useMemo(() => {
    const currentValueNumber = helpers.transform.toInt10(currentValuePercentages);
    if (currentValueNumber && currentValueNumber > 0 && currentValueNumber <= 100) {
      return currentValueNumber;
    }

    return currentValueNumber > 100 ? 100 : 0;
  }, [currentValuePercentages]);

  return (
    <Box
      sx={{
        width: '100%',
        ...containerOptions || {},
      }}
    >
      <LinearProgress
        variant="determinate"
        value={linearProgressValue}
        sx={{
          height: '6px',
          borderRadius: '10px',
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: colorPrimary || '#EEEEEE',
          },
          [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: colorBar || '#57B894',
          },
          ...linearProgressOptions || {},
        }}
      />
    </Box>
  );
}

ProgressBar.propTypes = {
  currentValuePercentages: PropTypes.number.isRequired,
  containerOptions: PropTypes.object,
  linearProgressOptions: PropTypes.object,
  colorPrimary: PropTypes.string,
  colorBar: PropTypes.string,
};

export default ProgressBar;
